import Trade from "../models/Trade";
export const TradeMixin = {
  data() {
    return {
      trade: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Trade({
          pair_id: undefined,
          role: 'MAKER',
          side: undefined,
          price: 0,
          amount: 0,
          fee: 0,
          status: 'NEW',
      })
    }
  }
}
